export default [
  {
    id: 1,
    type: "default",
    title: "",
    question:
      "What difficulty are you facing currently with your child's education?",
    answers: [
      {
        id: "1.1",
        text:
          "Dissatisfied with some aspect of public-school or private school education",
      },
      {
        id: "1.2",
        text: "Unable to find time to homeschool effectively",
      },
      {
        id: "1.3",
        text: "Unable to find the correct resources to homeschool effectively",
      },
      {
        id: "1.4",
        text: " Facing resistance from my child when homeschooling",
      },
    ],
  },
  {
    id: 2,
    type: "default",
    title: "",
    question: "What would be the ideal solution for your educational needs?",
    answers: [
      {
        id: "2.1",
        text: "A better public school that my child could attend",
      },
      {
        id: "2.2",
        text: "An affordable private school that my child could attend",
      },
      {
        id: "2.3",
        text: "A better homeschooling curriculum",
      },
      {
        id: "2.4",
        text:
          "An affordable online platform with a personalized approach for your family that would allow you to homeschool your child in an effective manner",
      },
    ],
  },
  {
    id: 3,
    type: "default",
    title: "",
    question:
      "How much would you be willing to pay for an online solution for all of your homeschooling needs?",
    answers: [
      {
        id: "3.1",
        text: "Up to $100/month",
      },
      {
        id: "3.2",
        text: "Up to $500/month",
      },
      {
        id: "3.3",
        text: "More than $500/month",
      },
      {
        id: "3.4",
        text: "Nothing at all",
      },
    ],
  },
  {
    id: 4,
    type: "default",
    title: "",
    question:
      "How much time would you be willing to commit to make your child's homeschooling experience a success?",
    answers: [
      {
        id: "4.1",
        text: "Up to 1 hour per day",
      },
      {
        id: "4.2",
        text: "Up to 3 hours per day",
      },
      {
        id: "4.3",
        text: "More than 3 hours per day",
      },
      {
        id: "4.4",
        text: "No time at all",
      },
    ],
  },

  {
    id: 5,
    type: "default",
    title: "",
    question: "Does your child have special needs?",
    answers: [
      {
        id: "5.1",
        text: "Yes",
      },
      {
        id: "5.2",
        text: "No",
      },
    ],
  },
  {
    id: 6,
    type: "ranking",
    title: "",
    question:
      "Assessment Test that generates customized homeschooling program recommendation",
  },
  {
    id: 7,
    type: "ranking",
    title: "",
    question:
      "Achievement score showing overall progress of student within a particular homeschooling program including recommendations for improvement",
  },
  {
    id: 8,
    type: "ranking",
    title: "",
    question:
      "Online Access to Personal Advisor who helps you with all your individual homeschooling needs",
  },
  {
    id: 9,
    type: "ranking",
    title: "",
    question:
      "Tutoring feature through which you'll gain access to many tutors qualified in your desired subjects from the convenience of your home",
  },
  {
    id: 10,
    type: "ranking",
    title: "",
    question:
      "Social Network component which will allow join other Smart Homeschooling families in discussions on various homeschooling topics",
  },
  {
    id: 11,
    type: "ranking",
    title: "",
    question:
      "Features tailored specifically to families with Special Needs children",
  },
  {
    id: 12,
    type: "ranking",
    title: "",
    question:
      "Specialized reports in the format required by your State to help you submit information, where required",
  },
  {
    id: 13,
    type: "textArea",
    title: "",
    canSkip: true,
    question:
      "How else can we make the Smart Homeschooling Platform the best solution for all of your child's educational needs?",
  },
  {
    id: 14,
    type: "default",
    title: "",
    question: "Are you currently homeschooling your children?",
    answers: [
      {
        id: "14.1",
        text: "Yes",
      },
      {
        id: "14.2",
        text: "No",
      },
    ],
  },
  {
    id: 15,
    type: "default",
    title: "",
    question:
      "If you are in public/private school, do you use after school programs?",
    answers: [
      {
        id: "15.1",
        text: "Yes",
      },
      {
        id: "15.2",
        text: "No",
      },
    ],
  },
  {
    id: 16,
    type: "default",
    title: "",
    question: "Do you use tutors?",
    answers: [
      {
        id: "16.1",
        text: "Yes",
      },
      {
        id: "16.2",
        text: "No",
      },
    ],
  },

  {
    id: 17,
    type: "email",
    title: "",
    question: "Email",
  },
  {
    id: 18,
    type: "name",
    title: "",
    question: "Name",
  },
  {
    id: 19,
    type: "final",
    title: "",
    question: "Success",
  },
];
